<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  [title]="'MEDIA.MODAL.PLAYLIST.DUPLICATE.TITLE' | translate"
  [submitText]="'MODAL.DEFAULT.SUBMIT' | translate"
  [loading]="isLoading$ | async"
  [hideCancelOnLoading]="true"
  [isSubmitDisabled]="duplicatePlaylistForm.invalid"
>
  <form [formGroup]="duplicatePlaylistForm">
    <div class="body-delete-track-modal-component">
      <div class="form-input rk-input-wrapper">
        <rk-form-field label="{{ 'MEDIA.MODAL.PLAYLIST.DUPLICATE.NAME' | translate }} ">
          <input formControlName="playlistName" rkInput type="text" />
        </rk-form-field>
      </div>
    </div>
  </form>
</rk-modal-wrapper>
